<template>
    <hts-modal
        :show="visible"
        :title="$t('labels.deleteInvoice')"
        type="confirm"
        :content="$t('labels.confirmInvoiceAccount')"
        @close="close"
        @confirm="() => handleDelete()" />
</template>

<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables'])
const id = ref('')
const close = () => {
  visible.value = false
  emits('close')
}

const handleDelete = () => {
  const api = {
    url: '/trip/tripId/billing-and-costing/invoice',
    method: 'delete'
  }

  $api(api, { body: { ids: [id.value] } }).then((data: any) => {
    const resData: any = data?.data?.value
    if (resData?.success) {
      process.client && $toast().success($t('labels.deleteSuccess'))
      emits('refreshTables')
      close()
    } else {
      // Freightek errors
    }
  })
}

const open = (idInvoice: string) => {
  id.value = idInvoice
  visible.value = true
}

defineExpose({
  open
})
</script>
